mutation ApprovalTestGroupUpdate($input: ApprovalTestGroupUpdateInput!) {
  approvalTestGroupUpdate(input: $input) {
    approvalTestGroup {
      id
      name
      _rowTimestamp
    }
  }
}
